var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.8333L29 35.3333H6.99998L18 18.8333ZM18 25.4333L13.8567 31.6667H22.1433L18 25.4333ZM16.0554 14.3611C14.9816 13.2872 14.9816 11.546 16.0554 10.4721C17.1293 9.39816 18.8706 9.39816 19.9446 10.4721C21.0184 11.546 21.0184 13.2872 19.9446 14.3611C18.8706 15.4351 17.1293 15.4351 16.0554 14.3611ZM5.68455 0.101196L8.27727 2.69391C2.90756 8.06364 2.90756 16.7697 8.27727 22.1394L5.68455 24.7321C-1.1171 17.9304 -1.1171 6.90283 5.68455 0.101196ZM30.3154 0.101196C37.1171 6.90283 37.1171 17.9304 30.3154 24.7321L27.7227 22.1394C33.0924 16.7697 33.0924 8.06364 27.7227 2.69391L30.3154 0.101196ZM10.87 5.28665L13.4627 7.87937C10.9569 10.3852 10.9569 14.448 13.4627 16.954L10.87 19.5467C6.93221 15.6089 6.93221 9.22443 10.87 5.28665ZM25.13 5.28665C29.0678 9.22443 29.0678 15.6089 25.13 19.5467L22.5373 16.954C25.0431 14.448 25.0431 10.3852 22.5373 7.87937L25.13 5.28665Z",
    fill: "#0AC79A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.ec916074016ab79da50abb0d3895097d.svg";
export { ForwardRef as ReactComponent };